<template>
  <div ref="filterItem">
    <slot></slot>
  </div>
</template>

<script>
  import emitter from '@/minxins/emitter'
  export default {
    name: "app-filter-item",
    mixins: [emitter],
    props: {
      priority: {
        type: [Number, String],
        default: 0
      }
    },
    mounted() {
      this.dispatch('app-filter-group', 'app.filterItem.addFilterItem', [this]);
    }
  }
</script>

<style scoped>

</style>
